import * as t from 'io-ts';

export const SimpleValueType = t.interface({
    value: t.union([t.number, t.null]),
});

export interface SimpleValueDTO extends t.TypeOf<typeof SimpleValueType> {
}

export class SimpleValue {
    value: number;

    constructor(params: SimpleValueDTO) {
        this.value = params.value ?? 0;
    }
}
